export default "__VITE_ASSET__CBp5NjFJ__"